import React, { useEffect } from 'react'
import { useWindowDimensions } from 'react-native'
import { useKeepAwake } from 'expo-keep-awake'
import { useTheme } from 'styled-components/native'

import { useSelector, useDispatch } from 'APP/Hooks/redux'
import { signals, packetLossStatuses } from 'APP/Lib/VideoSession/constants'
import sprigClient from 'APP/Services/Sprig'
import I18n from 'APP/I18n'
import usePrevious from 'APP/Hooks/usePrevious'
import PublisherView from 'APP/NativeComponents/PublisherView.web'
import SubscriberView from 'APP/NativeComponents/SubscriberView.web'
import VideoCallPacketLossIndicator from 'APP/Components/VideoCallPacketLossIndicator'

import Actions from './Actions.web'
import {
  Container,
  VideoContainer,
  VideosContainer,
  pubPacketLossOverlayContainer,
} from './style.web'
import { videoSessionActions } from 'APP/Store/VideoSession'

const VideoCallScreen = () => {
  useKeepAwake()
  const dispatch = useDispatch()
  const theme = useTheme()
  const { height, width } = useWindowDimensions()
  const stacked = height >= width

  const videoSession = useSelector((state) => state.videoSession)
  const { currentLossStatus } = useSelector((state) => state.videoSession.publisherStats)
  const hasCriticalPacketLoss = currentLossStatus === packetLossStatuses.CRITICAL
  const hasPacketLoss = hasCriticalPacketLoss || currentLossStatus === packetLossStatuses.WARNING

  const practitionerStream = videoSession.streams.find(
    (stream) => stream.name === signals.properties.senderTypes.CARE_PLATFORM
  )
  const previousCurrentLossStatus = usePrevious(currentLossStatus)

  useEffect(() => {
    if (previousCurrentLossStatus !== currentLossStatus) {
      dispatch(
        videoSessionActions.trackVideoQualityStats({
          current: currentLossStatus,
          previous: previousCurrentLossStatus,
        })
      )
    }
    return () => {
      sprigClient.track(`VIDEO_CONSULTATION_ENDED_${I18n.baseLocale.toUpperCase()}`, {
        episode_id: videoSession.episodeId,
      })
    }
  }, [dispatch, currentLossStatus, previousCurrentLossStatus, videoSession.episodeId])

  return (
    <Container>
      <VideosContainer testID="VIDEO_CALL_VIDEOS" $stacked={stacked}>
        <VideoContainer testID="PRACTITIONER_VIDEO_CONTAINER" $stacked={stacked}>
          <SubscriberView
            streamId={practitionerStream?.streamId}
            isMuted={!practitionerStream?.hasAudio}
            isVideoOff={!practitionerStream?.hasVideo}
          />
        </VideoContainer>
        <VideoContainer testID="PUBLISHER_VIDEO_CONTAINER" $stacked={stacked}>
          <PublisherView
            sessionId={videoSession.sessionId}
            isMuted={videoSession.patientIsMuted}
            isCameraOff={false}
          />
        </VideoContainer>
      </VideosContainer>
      <Actions />
      <VideoCallPacketLossIndicator
        containerStyle={pubPacketLossOverlayContainer(theme)}
        hasPacketLoss={hasPacketLoss}
        hasCriticalPacketLoss={hasCriticalPacketLoss}
      />
    </Container>
  )
}

export default VideoCallScreen
